import React from 'react';
import { VariantType, useSnackbar } from 'notistack';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';

let useSnackbarRef: any;

export const SnackbarUtilsConfigurator: React.FC = () => {
  useSnackbarRef = useSnackbar();
  return null;
};

const getIcon = (variant: VariantType) => {
  switch (variant) {
    case 'success':
      return <CheckCircleIcon style={{ color: 'green' }} />;
    case 'error':
      return <ErrorIcon style={{ color: 'red' }} />;
    case 'info':
      return <InfoIcon style={{ color: '#2196f3' }} />;
    case 'warning':
      return <WarningIcon style={{ color: '#ff9800' }} />;
    default:
      return null;
  }
};

const getBorderColor = (variant: VariantType) => {
  switch (variant) {
    case 'success':
      return 'green';
    case 'error':
      return 'red';
    case 'info':
      return '#2196f3';
    case 'warning':
      return '#ff9800';
    default:
      return 'gray';
  }
};

interface NotifyOptions {
  title: string;
  description: string;
  variant: VariantType;
}

const notify = ({ title, description, variant }: NotifyOptions) => {
  useSnackbarRef.enqueueSnackbar(description, {
    variant,
    autoHideDuration: 20000,
 content: (snackbarKey: string | number) => (
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            backgroundColor: '#fff',
            padding: '12px 16px',
            borderRadius: '6px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            borderLeft: `6px solid ${getBorderColor(variant)}`,
            maxWidth: 400,
            width: '100%',
            gap: '8px',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'flex-start', flex: 1 }}>
            <span style={{ marginRight: 12 }}>{getIcon(variant)}</span>
            <div style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
              <strong style={{ textTransform: 'capitalize', display: 'block', marginBottom: 4 }}>
                {title}
              </strong>
              <div style={{ fontSize: '0.9rem', lineHeight: 1.4 }}>
                {description}
              </div>
            </div>
          </div>
          <button
            onClick={() => useSnackbarRef.closeSnackbar(snackbarKey)}
            style={{
              background: 'transparent',
              border: 'none',
              fontSize: '1.1rem',
              cursor: 'pointer',
              color: '#999',
              padding: 0,
              lineHeight: '1',
            }}
            aria-label="Close"
          >
            ×
          </button>
        </div>
      ),
    });
};

export default notify;
